import type { ReflectionNote } from "@couples/shared";

import { supabase } from "../supabase";

interface NoteRow {
  id: string;
  couple_id: string;
  created_by: string;
  title: string;
  occurred_on: string;
  resolved: boolean;
  resolved_by: string | null;
  resolved_at: string | null;
  created_at: string;
}

const COLUMNS =
  "id, couple_id, created_by, title, occurred_on, resolved, resolved_by, resolved_at, created_at";

function toNote(row: NoteRow): ReflectionNote {
  return {
    id: row.id,
    coupleId: row.couple_id,
    createdBy: row.created_by,
    title: row.title,
    occurredOn: row.occurred_on,
    resolved: row.resolved,
    resolvedBy: row.resolved_by,
    resolvedAt: row.resolved_at,
    createdAt: row.created_at,
  };
}

/** ふりかえりノートの一覧。出来事の日付が新しい順 */
export async function fetchNotes(): Promise<ReflectionNote[]> {
  const { data, error } = await supabase
    .from("reflection_notes")
    .select(COLUMNS)
    .order("occurred_on", { ascending: false });
  if (error) throw error;
  const rows: NoteRow[] = data;
  return rows.map(toNote);
}

export interface NoteInput {
  title: string;
  /** `YYYY-MM-DD` */
  occurredOn: string;
}

/** couple_id / created_by は DB 側の既定値でセッションから埋まる */
export async function createNote(input: NoteInput): Promise<ReflectionNote> {
  const { data, error } = await supabase
    .from("reflection_notes")
    .insert({ title: input.title, occurred_on: input.occurredOn })
    .select(COLUMNS)
    .single();
  if (error) throw error;
  return toNote(data);
}

/** 「解決済み」にする。タイトル・日付はRLSの列単位グラントで書き換えられない */
export async function resolveNote(id: string, resolvedBy: string): Promise<void> {
  const { error } = await supabase
    .from("reflection_notes")
    .update({ resolved: true, resolved_by: resolvedBy, resolved_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error;
}
